export default __webpack_public_path__ + "assets/58675b2557a34dd4a2707192959bbd41.png";